import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { FilePresent } from "@mui/icons-material";
import { LangConstant } from "@/const";
import { ResponseRequestType } from "@/types/service";

type SelectedRequestsProps = {
  requests: ResponseRequestType[];
};

const SelectedRequests: FC<SelectedRequestsProps> = ({ requests }) => {
  const { t: getLabel } = useTranslation(LangConstant.NS_REQUEST);

  return (
    <Box>
      {requests.length === 0 ? (
        <Typography variant="caption" color="error">
          {getLabel("L_NO_SELECTED_REQUEST")}
        </Typography>
      ) : (
        <>
          <Typography variant="h6" marginBottom="16px">
            {getLabel("L_SELECTED_REQUEST_TITLE")}:
          </Typography>
          {requests.map(request => (
            <Box key={request.uid} display="flex" alignItems="center" marginBottom="16px">
              <FilePresent color="primary" />
              <Typography marginLeft="8px">{request.uid}</Typography>
            </Box>
          ))}
        </>
      )}
    </Box>
  );
};

export default SelectedRequests;
